import ApiService from "../../../services/ApiService";

async function assertOk(request) {
    const result = await request;
    if (result?.code && result.code !== "SUCCESS") {
        throw new Error(result.message || "Request failed");
    }
    return result;
}

const AdminJourneyMapService = {
    listTracks: async () => {
        const result = await assertOk(ApiService.getData("/v1/journey/tracks"));
        return result?.tracks || [];
    },

    getMapSummary: async (trackId) => {
        const id = encodeURIComponent(trackId);
        return assertOk(ApiService.getData(`/v1/journey/tracks/${id}/map?includeLevels=false`));
    },

    /** Center-crop the original master to a portrait or landscape phone background and save it. */
    cropChapterBackground: async (trackId, chapterNo, width, height) => {
        const id = encodeURIComponent(trackId);
        return assertOk(
            ApiService.postData(`/v1/journey/tracks/${id}/chapters/${chapterNo}/image-background`, {
                width,
                height,
            })
        );
    },
    cropChapterImage: async (trackId, chapterNo, crop) => {
        const id = encodeURIComponent(trackId);
        return assertOk(
            ApiService.postData(`/v1/journey/tracks/${id}/chapters/${chapterNo}/image-crop`, {
                x: Math.round(crop.x),
                y: Math.round(crop.y),
                size: Math.round(crop.size),
            })
        );
    },

    renameTrack: async (trackId, title) => {
        const id = encodeURIComponent(trackId);
        return assertOk(ApiService.putData(`/v1/journey/tracks/${id}/title`, { title }));
    },

    renameChapter: async (trackId, chapterNo, title) => {
        const id = encodeURIComponent(trackId);
        return assertOk(
            ApiService.putData(`/v1/journey/tracks/${id}/chapters/${chapterNo}/title`, { title })
        );
    },

    /** Bedrock postcard for one chapter. Returns image URLs when the row is ready. */
    generateChapterImage: async (trackId, chapterNo) => {
        const id = encodeURIComponent(trackId);
        return assertOk(ApiService.postData(`/v1/journey/tracks/${id}/chapters/${chapterNo}/image`, {}));
    },
};

export default AdminJourneyMapService;
